<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container design-wrapper">
  <h2>Designs</h2>
  <hr />
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li routerLink="/home" class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link">Home</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a routerLink="/design" class="breadcrumb__list__list-item__link">Designs</a>
      </li>
    </ul>
  </div>
  <form action="">
    <div class="input-wrapper">
      <mat-form-field appearance="fill" class="d-flex search-field">
        <mat-icon>search</mat-icon>
        <input matInput [(ngModel)]="searchDesign" name="search" placeholder="Placeholder" />
      </mat-form-field>
    </div>
  </form>
  <div class="d-flex justify-content-start" style="margin-bottom: 40px !important;">
    <button mat-flat-button color="primary" class="add-new-btn" [routerLink]="['/design-form']">
      <mat-icon>add</mat-icon> New Design
    </button>
  </div>
  <div class="row">
    <div class="design-wrapper__item col-md-4 col-12 px-3" *ngFor="let design of designs | appFilter: searchDesign;">
      <mat-card class="w-100 d-flex flex-column">

        <div class="flex-grow-1 flex-column d-flex">
          <h2 class="design-wrapper__item__title" style="text-align:center;">{{ design.name }}</h2>
          <!--<p class="design-wrapper__item__detail">{{ design.id }}</p> -->
        </div>
        <div class="d-flex flex-wrap w-100">
          <div class="col-lg-6 col-12 mb-3 pe-lg-2">
            <button [routerLink]="['/design-overview']" [queryParams]="{ id: design.id }" mat-flat-button
              class="mt-auto view-design w-100" color="accent">
              View Design
            </button>
          </div>
          <div class="col-lg-6 col-12 mb-3 ps-lg-2">
            <button mat-flat-button class="mt-auto set-design w-100" color="primary" [routerLink]="['/design-form']"
              [queryParams]="{ id: design.id,mode:'Copy' }">
              Copy Design
            </button>
          </div>
          <div class="col-12">
            <button [routerLink]="['/design-systems']" [queryParams]="{ id: design.id,editMode:false}" mat-flat-button
              class="mt-auto system w-100" color="primary">
              Systems
            </button>
          </div>
        </div>

      </mat-card>
    </div>
  </div>

</div>
